import { withStyles } from '@material-ui/core';

import OrderSwitcher from './component';
import styles from './styles';

export default withStyles(styles)(OrderSwitcher);
